import React, {useMemo} from 'react'
import clsx from 'clsx'
import {ProgressBar} from './ProgressBar/index.ts'
import {ProgressDate} from './ProgressDate/index.ts'
import styles from './SeasonProgress.module.scss'

export interface SeasonProgressProps {
    className?: string
    startDate: Date | undefined
    endDate: Date | undefined
    size: 'sm' | 'md'
}

export const SeasonProgress = ({
    className,
    startDate,
    endDate,
    size = 'md',
}: SeasonProgressProps) => {
    const {seasonTimeRemaining, progress} = useMemo(() => {
        if(!startDate || !endDate) return {seasonTimeRemaining: undefined, progress: undefined}
        const totalSeasonLength = endDate.getTime() - startDate.getTime()
        const timeRemaining = endDate.getTime() - new Date().getTime()
        return {
            seasonTimeRemaining: timeRemaining,
            progress: (totalSeasonLength - timeRemaining) / totalSeasonLength * 100,
        }
    }, [startDate, endDate])

    return (
        <div className={clsx(styles.seasonProgressContainer, className)}>
            <ProgressDate seasonTimeRemaining={seasonTimeRemaining} />
            <ProgressBar progress={progress} size={size} />
        </div>
    )
}
